<template>
  <div style="padding: 5px">
    <div class="menu">
      <header>
        <h2>{{ $t('menu.title') }}</h2>
        <a-space>
          <a-button type="primary" @click="handleSearch" v-if="authorities.find(a =>  a.code === 'auth:menu:query')">{{ $t('buttons.search') }}</a-button>
          <a-button type="primary" @click="addMenu()" v-if="authorities.find(a => a.code === 'auth:menu:insert')">{{ $t('buttons.add') }}</a-button>
        </a-space>
      </header>
      <a-table
        :columns="columns"
        :data-source="data"
        :row-key="record => record.id"
        :pagination="pagination"
        :loading="isLoading"
        :scroll="scroll"
        @change="handleTableChange"
      >
        <template v-slot:detailsName="text">
          <text-highlight :queries="[highLightInfo['details.name']]">{{text}}</text-highlight>
        </template>
        <template v-slot:pid="text">
          {{ pids[text][lang] }}
        </template>
        <template v-slot:icon="text">
          <a-icon :type="text" style="font-size: 20px" />
        </template>
        <template v-slot:enabled="text">
          {{ text ? $t('common.yes') : $t('common.no') }}
        </template>
        <template v-slot:isMobile="text">
          {{ platforms[text][lang] }}
        </template>
        <template #operation="text, record">
          <a-button type="link" style="padding-left: 0" @click="addMenu(record)" v-if="authorities.find(a => a.code === 'auth:menu:insert')" v-show="record.type==0">{{ $t('buttons.add') }}</a-button>
          <a-button type="link" style="padding-left: 0" @click="showEditModal(record)" v-if="authorities.find(a => a.code === 'auth:menu:update')">{{ $t('buttons.edit') }}</a-button>
          <a-popconfirm
            :key="lang"
            v-if="authorities.find(a => a.code === 'auth:menu:delete')"
            :title="$t('messages.ctrd')"
            :ok-text="$t('common.okText')"
            :cancel-text="$t('common.cancelText')"
            @confirm="removeMenu(record)"
          >
            <a href="#">{{ $t('buttons.delete') }}</a>
          </a-popconfirm>
        </template>
      </a-table>
      <a-modal v-model="visible" :title="title" :width="800" @ok="submitForm" @cancel="clearForm">
        <a-form-model :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">
          <a-form-model-item :label="$t('menu.pMenu')" prop="pid">
            <a-select v-model="form.pid">
              <a-select-option v-for="(value, key) in pids" :key="key" :value="key">
                {{ value[lang] }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item :label="$t('menu.type')" required>
            <a-select v-model="form.type">
              <a-select-option :value="0">{{ $t('menu.catalogue') }}</a-select-option>
              <a-select-option :value="1">{{ $t('menu.menu') }}</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item :label="$t('menu.icon')" prop="icon">
            <a-input v-model="form.icon" />
          </a-form-model-item>
          <a-form-model-item :label="$t('menu.route')" prop="route">
            <a-input v-model="form.route" />
          </a-form-model-item>
          <a-form-model-item :label="$t('menu.alias')" prop="routeName">
            <a-input v-model="form.routeName" />
          </a-form-model-item>
          <a-form-model-item :label="$t('menu.name')" prop="zh-CN">
            <a-input v-model="form['zh-CN']" />
          </a-form-model-item>
          <a-form-model-item :label="$t('menu.englishName')" prop="en-US">
            <a-input v-model="form['en-US']" />
          </a-form-model-item>
          <a-form-model-item :label="$t('menu.priority')" prop="priority">
            <a-input-number style="width: 100%" v-model="form.priority" />
          </a-form-model-item>
          <a-form-model-item :label="$t('menu.isMobile')" prop="isMobile">
            <a-select v-model="form.isMobile">
              <a-select-option :value="2">{{ platforms[2][lang] }}</a-select-option>
              <a-select-option :value="1">{{ platforms[1][lang] }}</a-select-option>
              <a-select-option :value="0">{{ platforms[0][lang] }}</a-select-option>
            </a-select>
          </a-form-model-item>
          <!-- <a-form-model-item :label="$t('menu.authorities')">
            <a-select :getPopupContainer="(triggerNode) => triggerNode.parentNode" mode="tags" v-model="selectedAuthorities">
              <a-select-option v-for="a in authoritiesList" :key="a.id" :value="a.id + ''">
                {{ a['zh-CN'] }}
              </a-select-option>
            </a-select>
          </a-form-model-item> -->
          <a-form-model-item :label="$t('user.modal.authorities')">
            <div data-v-1ac917c8 tabindex="-1" class="ant-select ant-select-enabled">
              <div
                role="combobox"
                aria-autocomplete="list"
                aria-haspopup="true"
                aria-controls="c38ed750-2683-4dd7-81d9-3cf691d34b3a"
                class="ant-select-selection ant-select-selection--multiple"
                @click="showAModal"
              >
                <div class="ant-select-selection__rendered">
                  <ul>
                    <li
                      v-for="(s, i) in selectedAuthorities"
                      :key="s.id"
                      unselectable="on"
                      role="presentation"
                      :title="s['zh-CN']"
                      class="ant-select-selection__choice"
                      style="user-select: none;"
                    >
                      <div class="ant-select-selection__choice__content">{{ s['zh-CN'] }}</div>
                      <span class="ant-select-selection__choice__remove" @click.stop="removeAS(i)">
                        <i
                          aria-label="图标: close"
                          class="anticon anticon-close ant-select-remove-icon"
                        >
                          <svg
                            viewBox="64 64 896 896"
                            data-icon="close"
                            width="1em"
                            height="1em"
                            fill="currentColor"
                            aria-hidden="true"
                            focusable="false"
                            class
                          >
                            <path
                              d="M563.8 512l262.5-312.9c4.4-5.2.7-13.1-6.1-13.1h-79.8c-4.7 0-9.2 2.1-12.3 5.7L511.6 449.8 295.1 191.7c-3-3.6-7.5-5.7-12.3-5.7H203c-6.8 0-10.5 7.9-6.1 13.1L459.4 512 196.9 824.9A7.95 7.95 0 0 0 203 838h79.8c4.7 0 9.2-2.1 12.3-5.7l216.5-258.1 216.5 258.1c3 3.6 7.5 5.7 12.3 5.7h79.8c6.8 0 10.5-7.9 6.1-13.1L563.8 512z"
                            />
                          </svg>
                        </i>
                      </span>
                    </li>
                    <li class="ant-select-search ant-select-search--inline">
                      <div class="ant-select-search__field__wrap">
                        <input autocomplete="off" value class="ant-select-search__field" />
                        <span class="ant-select-search__field__mirror">&nbsp;</span>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </a-form-model-item>
          <a-form-model-item :label="$t('menu.enabled')">
            <a-switch v-model="form.enabled" />
          </a-form-model-item>
        </a-form-model>
        <a-modal v-model="isAShow" title="权限列表" :width="800" class="authoritiesList" @ok="confirmA">
          <a-table
            :loading="isALoading"
            :columns="aColumns"
            :data-source="authoritiesList"
            row-key="id"
            :row-selection="{ selectedRowKeys: selectedA, onChange: selectA }"
          >
            <template v-slot:requiredCaptcha="text">
              {{ text ? '是' : '否' }}
            </template>
            <template v-slot:icon="text">
              <a-icon :type="text" style="font-size: 20px" />
            </template>
            <template v-slot:enabled="text">
              {{ text ? '是' : '否' }}
            </template>
          </a-table>
        </a-modal>
      </a-modal>
    </div>
  </div>
</template>

<script>
const titleMap = {
  add: {
    zh: '新增菜单',
    en: 'Add menu'
  },
  edit: {
    zh: '编辑菜单',
    en: 'edit menu'
  }
}

import moment from 'moment'
import {
  searchMenuList,
  addMenu,
  removeMenu,
  updateMenu,
  getMenu,
  getAuthoritiesList
} from '@/api/auth/menu'
import TextHighlight from 'vue-text-highlight'

export default {
  components: {TextHighlight},
  data() {
    return {
      data: [],
      highLightInfo: {
        'details.name': ''
      },
      authorities: [],
      labelCol: { span: 4 },
      wrapperCol: { span: 16 },
      visible: false,
      isLoading: false,
      columns: [
        {
          title: () => (<div>{ this.$t('menu.name') }<a-input allow-clear class="search" type="text" data-index="0" /></div>),
          dataIndex: 'zh-CN',
          key: 'details.name',
          scopedSlots: {
            customRender: 'detailsName'
          }
        },
        {
          title: () => (<div>{ this.$t('menu.isMobile') }<br /><a-select class="username" default-value="3" data-index="1" style="width: 120px; margin-left: -5px"><a-select-option value="3">{ this.$t('common.all') }</a-select-option><a-select-option value="0">{ this.platforms[0][this.lang] }</a-select-option><a-select-option value="1">{ this.platforms[1][this.lang] }</a-select-option><a-select-option value="2">{ this.platforms[2][this.lang] }</a-select-option></a-select></div>),
          dataIndex: 'isMobile',
          key: 'isMobile',
          scopedSlots: {
            customRender: 'isMobile'
          }
        },
        {
          title: () => this.$t('menu.icon'),
          dataIndex: 'icon',
          key: 'icon',
          width: '12%',
          scopedSlots: {
            customRender: 'icon'
          }
        },
        {
          title: () => this.$t('menu.pMenu'),
          dataIndex: 'pid',
          key: 'pid',
          scopedSlots: {
            customRender: 'pid'
          }
        },
        {
          title: () => (<div>{ this.$t('common.createdAt') }<span class="icons unset" style="cursor: pointer; right: -52px" data-index="4"><a-icon type="caret-up" /><a-icon type="caret-down" /></span></div>),
          dataIndex: 'createdAt',
          width: 200,
          key: 'createdAt'
        },
        {
          title: () => (<div>{ this.$t('common.updatedAt') }<span class="icons DESC" style="cursor: pointer; right: -52px" data-index="5"><a-icon type="caret-up" /><a-icon type="caret-down" /></span></div>),
          dataIndex: 'updatedAt',
          key: 'updatedAt',
          width: 200
        },
        {
          title: () => this.$t('menu.enabled'),
          dataIndex: 'enabled',
          key: 'enabled',
          scopedSlots: {
            customRender: 'enabled'
          }
        },
        {
          title: () => this.$t('common.operation'),
          dataIndex: 'operation',
          key: 'operation',
          align: 'left',
          scopedSlots: { customRender: 'operation' },
          fixed: 'right'
        }
      ],
      authoritiesList: [],
      pagination: {
        current: 1,
        pageSize: 100,
        total: 0
      },
      pids: {
        0: {
          zh: '无',
          en: 'none'
        }
      },
      sortInfo: [],
      searchInfo: {
        text: {
          protocolCode: '',
          protocolName: ''
        },
        column: {
          protocolCode: false,
          protocolName: false
        }
      },
      title: '',
      environments: ['PC', '移动', '移动和PC'],
      form: {
        pid: '0',
        code: null,
        icon: '',
        route: '',
        routeName: '',
        type: 1,
        externalLink: false,
        enabled: true,
        details: [
          {
            name: '',
            description: null,
            locale: 'zh-CN'
          },
          {
            name: '',
            description: null,
            locale: 'en-US'
          }
        ],
        routeMeta: {
          flag: 1
        },
        'zh-CN': '',
        'en-US': '',
        isMobile: undefined,
        priority: undefined
      },
      rules: {
        pid: [
          {
            required: true,
            zh: '请选择父级菜单',
            en: 'Please select a parent menu'
          }
        ],
        type: [
          {
            required: true,
            zh: '请选择菜单类型',
            en: 'Please select type'
          }
        ],
        route: [
          {
            required: true,
            zh: '请输入路径',
            en: 'Please enter route',
            trigger: 'blur'
          }
        ],
        routeName: [
          {
            required: true,
            zh: '请输入路径名',
            en: 'Please enter route alias',
            trigger: 'blur'
          }
        ],
        'zh-CN': [
          {
            required: true,
            zh: '请输入菜单名称',
            en: 'Please enter name',
            trigger: 'blur'
          }
        ]
      },
      scroll: {
        x: false
      },
      platforms: [
        {
          zh: 'PC',
          en: 'PC'
        },
        {
          zh: '移动',
          en: 'mobile'
        },
        {
          zh: '移动和PC',
          en: 'mobile and PC'
        }
      ],
      selectedAuthorities: [],
      authoritiesList: [],
      authoritiesList_origin: [],
      selectedA: [],
      aPagination: {
        current: 1,
        total: 0,
        pageSize: 10
      },
      isAShow: false,
      isALoading: false,
      aColumns: [
        {
          title: 'id',
          dataIndex: 'id',
          key: 'id'
        },
        {
          title: () => <div>权限名称<a-input onKeyup={ e => this.handleKeyup(e, 'zh-CN') } allow-clear type="text" data-index="1" /></div>,
          dataIndex: 'zh-CN',
          key: 'zh-CN'
        },
        {
          title: <div>权限编码<a-input onKeyup={ e => this.handleKeyup(e, 'code') } allow-clear type="text" data-index="2" /></div>,
          dataIndex: 'code',
          key: 'code'
        }
      ]

    }
  },
  computed: {
    lang() {
      return this.$store.state.lang
    }
  },
  watch: {
    visible(value) {
      if (value) {
        this.selectFlag = false
      } else {
        this.selectFlag = true
      }
    },
    lang: {
      immediate: true,
      handler(v) {
        if (v === 'en') {
          this.columns[0].dataIndex = 'en-US'
        }
        if (v === 'zh') {
          this.columns[0].dataIndex = 'zh-CN'
        }
        this.setRules()
      }
    }
  },
  created() {
    this.state = 'add'
    this.title = titleMap[this.state][this.lang]
    this.selectFlag = true
    this.queryParams = {
      query: [],
      filter: [],
      sort: [
        {
          field: 'updatedAt',
          value: 'DESC'
        }
      ]
    }
  },
  mounted() {
    this.getMenuList()
      const ss = document.querySelectorAll('.menu .ant-table-column-title > div span.icons')
      ss.forEach(i => {
        i.addEventListener('click', () => {
          let c = ''
          switch (i.classList[1]) {
            case 'ASC':
              c = 'DESC'
              break;
            case 'DESC':
              c = 'unset'
              break;
            case 'unset':
              c = 'ASC'
              break;
            default:
              break;
          }
          i.classList.remove(i.classList[1])
          i.classList.add(c)
          const ii = document.querySelectorAll('.menu .ant-table-column-title > div span.icons:not(.unset)')
          const sort = Array.from(ii).map(item => {
            const index = +item.dataset['index']
            console.log(item.classList);
            return {
              field: this.columns[index].key,
              value: item.classList[1]
            }
          })
          this.queryParams.sort = sort
          this.searchMenuList()
        })
      })
      const ips = document.querySelectorAll('.search .ant-input')
      ips.forEach(ip => {
        ip.addEventListener('keyup', ({ key, target }) => {
          // console.log(key, target.value.trim())
          if (key === 'Enter') {
            target.value = target.value.trim()
            // target.value.trim() && this.handleSearch()
            this.handleSearch()
          }
        })
        ip.addEventListener('blur', ({ target }) => {
          target.value = target.value.trim()
        })
      })
      this.getAuthoritiesList()
      this.s = document.querySelector('body')
      this.s.addEventListener('click', this.handleSelect)
      const width = window.innerWidth
      if (width < 1600) {
        this.scroll.x = 1350
      } else if (width < 1900) {
        this.scroll.x = 1647
      } else {
        this.scroll.x = false
      }
  },
  activated() {
    const a = JSON.parse(sessionStorage.getItem('authorities'))
    if (a?.length) {
      this.authorities = a
      console.log(a);
    } else {
      this.authorities = this.getAuthorities(this.$route.path)
    }
    this.s = document.querySelector('body')
    this.s.addEventListener('click', this.handleSelect)
  },
  deactivated() {
    this.s.removeEventListener('click', this.handleSelect)
    this.s = null
  },
  methods: {
    setRules() {
      for (let k in this.rules) {
        this.rules[k][0].message = this.rules[k][0][this.lang]
      }
    },
    async getMenuList() {
      this.searchMenuList()
    },
    handleSelect(e) {
      if(e.target.classList[1] === 'ant-select-dropdown-menu-item-selected' && this.selectFlag) {
        const value = e.target.innerText
        const index = this.platforms.findIndex(p => p.zh === value || p.en === value)
        if (index > -1) {
          this.queryParams.filter = [
            {
              field: 'isMobile',
              value: index
            }
          ]
        } else {
          this.queryParams.filter = []
        }
        this.searchMenuList()
      }
    },
    async getAuthoritiesList() {
      this.a = {}
      const { data } = await getAuthoritiesList()
      this.authoritiesList_origin = this.authoritiesList = data.map(d => {
        d.details.forEach(dd => {
          d[dd.locale] = dd.name
        })
        this.a[d.id] = d
        return d
      })
    },
    setAuthorities(value) {
      this.form.authorities = value.map(i => {
        return {
          id: +i
        }
      })
      this.$forceUpdate()
    },
    handleSearch() {
      this.pagination.current = 1
      const ips = document.querySelectorAll('.search .ant-input')
      this.queryParams.query = []
      ips.forEach(ip => {
        if (ip.value.trim()) {
          console.log(ip.value.indexOf('管'));
          this.queryParams.filter = []
          if (ip.value.indexOf('管') !== -1 || ip.value.indexOf('理') !== -1) {
            this.queryParams.filter = [
              {
                field: 'pid',
                value: 0
              }
            ]
          }
          this.queryParams.query.push({
            field: this.columns[+ip.dataset['index']].key,
            value: ip.value
          })
          this.highLightInfo[this.columns[+ip.dataset['index']].key] = ip.value
        } else {
          this.queryParams.filter = [
            {
              field: 'pid',
              value: 0
            }
          ]
          this.highLightInfo[this.columns[+ip.dataset['index']].key] = ''
        }
      })
      this.searchMenuList()
    },
    async searchMenuList(callback) {
      this.isLoading = true
      try {
        const { data } = await searchMenuList(this.pagination.current, this.pagination.pageSize, this.queryParams)
        for (let i = 0; i < data.records.length; i++) {
          this.setTreeData(data.records[i])
        }
        this.data = data.records
        if (callback) {
          this.search = true
          await callback()
          this.pagination.current = data.current
          this.pagination.total = data.total
        } else {
          this.pagination.current = data.current
          this.pagination.total = data.total
        }
      } finally {
        this.isLoading = false
      }
    },
    async handleReset(clearFilters, dataIndex) {
      clearFilters()
      this.searchInfo.text[dataIndex] = ''
      this.searchInfo.column[dataIndex] = false
      this.query.query[0].value = ''
      this.searchMenuList()
    },
    async removeMenu(record) {
      try {
        const { message } = await removeMenu(record.id)
        this.$message.success(message)
        this.searchMenuList()
      } catch(e) {
        console.log(e)
        this.$message.error(this.$t('messages.ftd'))
      }
    },
    async submitForm() {
      try {
        const form = { ...this.form, pid: +this.form.pid }
        form.details = [
          {
            name: form['zh-CN'],
            description: null,
            locale: 'zh-CN'
          },
          {
            name: form['en-US'],
            description: null,
            locale: 'en-US'
          }
        ]
        delete form["en-US"]
        delete form["zh-CN"]
        form.authorities = this.selectedAuthorities.map(s => {
          return {
            id: +s.id
          }
        })
        if (this.form.id) {
          // form.authorities = [
          //   {
          //     id: 1
          //   },
          //   {
          //     id: 2
          //   },
          //   {
          //     id: 3
          //   },
          //   {
          //     id: 4
          //   },
          //   {
          //     id: 5
          //   },
          //   {
          //     id: 6
          //   }
          // ]
          // form.authorities = this.form.authorities.map(a => ({ id: a.id }))
          const { message } = await updateMenu(form)
          this.$message.success(message)
        } else {
          const { message } = await addMenu(form)
          this.$message.success(message)
        }
        this.searchMenuList()
        this.visible = false
        this.clearForm()
      } catch(e) {
        console.log(e)
      }
    },
    addMenu(record) {
      this.state = 'add'
      this.title = titleMap[this.state][this.lang]
      this.visible = true
      if (record) {
        this.form.pid = record.id+''
      }
    },
    async showEditModal(record) {
      this.state = 'edit'
      this.title = titleMap[this.state][this.lang]
      const { data } = await getMenu(record.id)
      record.details.forEach(r => {
        this.form[r.locale] = r.name
      })
      for (let key in this.form) {
        if(key === 'pid') {
          this.form[key] = record[key] + ''
        } else {
          this.form[key] = record[key]
        }
      }
      this.form.id = record.id
      this.visible = true
      console.log(data.authorities)
      this.selectedAuthorities = data.authorities.map(d => {
        d.details.forEach(dd => {
          d[dd.locale] = dd.name
        })
        this.a[d.id] = d
        return d
      })
      console.log(this.form);
    },
    clearForm() {
      this.form = {
        pid: '5',
        code: null,
        icon: '',
        route: '',
        routeName: '',
        type: 1,
        externalLink: false,
        enabled: true,
        details: [
          {
            name: '',
            description: null,
            locale: 'zh-CN'
          },
          {
            name: '',
            description: null,
            locale: 'en-US'
          }
        ],
        routeMeta: {
          flag: 1
        },
        'zh-CN': '',
        'en-US': '',
        isMobile: undefined,
        priority: undefined
      }
      this.selectedAuthorities = []
    },
    handleTableChange(pagination) {
      this.pagination = pagination
      this.searchMenuList()
    },
    setTreeData(item) {
      item.createdAt = item.createdAt && moment(item.createdAt).format('YYYY-MM-DD HH:mm:ss')
      item.updatedAt = item.createdAt && moment(item.updatedAt).format('YYYY-MM-DD HH:mm:ss')
      item.details.forEach(d => {
        item[d.locale] = d.name
      })
      if (!item['zh-CN']) {
        item['zh-CN'] = item['en-US']
      }
      this.pids[item.id] = {
        zh: item['zh-CN'],
        en: item['en-US']
      }
      if (item.children && item.children.length) {
        for (let i = 0; i < item.children.length; i++) {
          this.setTreeData(item.children[i])
        }
      } else {
        item.children = null
      }
    },
    removeAS(i) {
      this.selectedAuthorities.splice(i, 1)
    },
    showAModal() {
      this.isAShow = true
      this.selectedA = this.selectedAuthorities.map(a => a.id)
    },
    confirmA() {
      this.selectedAuthorities = this.selectedA.map(s => this.a[s])
      this.isAShow = false
    },
    selectA(rows) {
      this.selectedA = rows
    },
    handleKeyup(e, field) {
      if (e.key === 'Enter') {
        e.target.value = e.target.value.trim()
        this.authoritiesList = this.authoritiesList_origin.filter(a => a[field].includes(e.target.value))
      }
    }
  }
}
</script>

<style lang="less" scoped>
.menu {
  margin: 20px;
  header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
.row {
  margin-top: 5px;
}
.highlight {
  background-color: rgb(255, 192, 105);
  padding: 0px;
}
.ant-table-column-title span {
  position: relative;
}
.ant-table-column-title .anticon-caret-up {
  position: absolute;
  top: -1px;
  right: -18px;
  font-size: 14px;
  color: #ccc;
}
.ant-table-column-title span.ASC .anticon-caret-up {
  color: #1890ff;
}
.ant-table-column-title span.DESC .anticon-caret-down {
  color: #1890ff;
}
.ant-table-column-title .anticon-caret-down {
  position: absolute;
  top: 8px;
  right: -18px;
  font-size: 14px;
  color: #ccc;
}
</style>